import { Button } from '@/global/components/Button'
import Menu from '@/global/components/Menu'
import { useAuth } from '@/hooks'
import { hasPermission } from '@/hooks/useBackendMenu'
import { useStore } from '@/store'
import { CategoriaEnum } from '@acme/auth'
import { SN } from '@acme/core'
import { PlusIcon } from 'lucide-react'

interface IProps {
    params?: string
}

export function AjustePontoButton({ params }: IProps) {
    const {
        decoded: { categoria },
    } = useAuth()
    const funcionario = useStore(state => state.employee)

    const isFuncionarioPermitido =
        categoria === CategoriaEnum.Funcionario &&
        SN.isTrue(funcionario?.ajustesPonto)

    const menuItens = [
        {
            title: 'Registro',
            show: isFuncionarioPermitido,
            href: `registros/adicionar`,
        },
        {
            title: 'Afastamento',
            show:
                isFuncionarioPermitido ||
                (categoria !== CategoriaEnum.Funcionario &&
                    (hasPermission(['create', 'Afastamentos']) ||
                        hasPermission(['create', 'Compensação']) ||
                        hasPermission(['create', 'Amamentação']) ||
                        hasPermission(['create', 'Folga']))),
            href: `afastamento/adicionar${params ? `?${params}` : ''}`,
        },
        {
            title: 'Abono',
            show:
                isFuncionarioPermitido ||
                (categoria !== CategoriaEnum.Funcionario &&
                    hasPermission(['create', 'Abonos'])),
            href: `abono/adicionar${params ? `?${params}` : ''}`,
        },
        {
            title: 'Compensação manual',
            show:
                categoria !== CategoriaEnum.Funcionario &&
                hasPermission(['create', 'CompensaçãoManual']) &&
                SN.isTrue(funcionario?.RegrasCalculo.compensacaoManual),
            href: `compensacao-manual/adicionar${params ? `?${params}` : ''}`,
        },
    ]

    if (!menuItens.some(item => item.show)) {
        return null
    }

    if (menuItens.filter(item => item.show).length === 1) {
        const item = menuItens.find(item => item.show)
        return (
            <Button
                href={item?.href}
                startIcon={<PlusIcon className="size-5" />}
            >
                {item?.title}
            </Button>
        )
    }

    return (
        <Menu.Root arrow>
            <Menu.Trigger>
                <Button startIcon={<PlusIcon className="size-5" />}>
                    Novo
                </Button>
            </Menu.Trigger>
            <Menu.List>
                {menuItens.map(item =>
                    item.show ? (
                        <Menu.Item key={item.title} href={item.href}>
                            {item.title}
                        </Menu.Item>
                    ) : null,
                )}
            </Menu.List>
        </Menu.Root>
    )
}
